import { OneMinuteInMillis, OneSecondInMillis } from '@racemap/utilities/consts/time';

export const MINIMAL_RELOAD_INTERVAL_PLAYER = 30 * OneSecondInMillis;
export const DEFAULT_RELOAD_INTERVAL_PLAYER = OneMinuteInMillis;
export const MAX_STARTERS_FOR_AUTO_RELOAD_PLAYER = 750;
